/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { ReactComponent as DocumentIcon } from '@assets/icons/document.svg';
import { ReactComponent as WordIcon } from '@assets/icons/word.svg';
import { ReactComponent as ExcelIcon } from '@assets/icons/excel.svg';
import { ReactComponent as FileIcon } from '@assets/icons/file.svg';

import { Typography } from '@atoms';
import { Tooltip } from 'antd';

import s from './styles.module.less';

const DocumentPreview = ({ title, className, extension }) => {
  
  return (
    <div className={clsx(s.wrapper, className)}>
      <Tooltip title={title} overlayClassName={s.customToolTip}>
        <div className={s.documentContainer}>
          { 
            (extension && extension === 'docx') ? <WordIcon className={s.icon} /> :
            (extension && extension === 'xlsx') ? <ExcelIcon className={s.icon} /> :
            (extension && extension === 'pdf') ? <DocumentIcon className={s.icon} /> :
            <FileIcon className={s.icon} />
          }
        </div>
      </Tooltip>
      <Typography.Text className={s.title} ellipsis>
        {title}
      </Typography.Text>
    </div>
  );
};

export default DocumentPreview;
